(function () {
    'use strict';

    angular.module("order")
        .controller('DeliveryAddressUpdateController', DeliveryAddressUpdateController);

    DeliveryAddressUpdateController.$inject = ['address', '$uibModalInstance', 'notificationSrvc', 'orderDeliveriesDataSrvc', 'orderUpdateMessagesConst', 'errorNotificationSrvc'];

    function DeliveryAddressUpdateController(address, $uibModalInstance, notificationSrvc, orderDeliveriesDataSrvc, orderUpdateMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            street: [],
            building_number: [],
            suite_number: [],
            city: [],
            zip_code: [],
            country: [],
            telephone: [],
            nonFieldErrors: []
        };
        self.addressData = {};
        angular.copy(address, self.addressData);

        self.updateOrderDeliveryAddress = updateOrderDeliveryAddress;
        self.close = close;
        self.cleanErrors = cleanErrors;

        function updateOrderDeliveryAddress() {
            orderDeliveriesDataSrvc.update({
                pk: self.addressData.pk
            }, self.addressData).$promise.then(
                function(response) {
                    angular.copy(self.addressData, address);
                    self.close();
                    notificationSrvc.notification("success", orderUpdateMessagesConst.updateDeliveryAddress);
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function close() {
            $uibModalInstance.close();
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
